import React from 'react'

import './PositionsListHeader.css'

const PositionsListHeader = ({ count }) => (
  <header className="align-items-center PositionsListHeader">
    <div className="d-flex flex-column justify-content-center text-center" style={{ flex: 1 }}>
      <h4>Offices</h4>
      {count} Available Offices
    </div>
  </header>
)

export default PositionsListHeader



// WEBPACK FOOTER //
// ./src/components/PositionsScene/PositionsList/PositionsListHeader/PositionsListHeader.js